import React from 'react'
import {Typography} from 'antd'
import {TextProps} from './props'

const {Text: AntText} = Typography

export const Text: React.FC<TextProps> = ({children, ...rest}: TextProps) => <AntText {...rest}>{children}</AntText>
